import React from 'react';
import { useNavigate } from 'react-router-dom';

const PropertyCard = ({ property, onClick }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (onClick) {
            onClick(property);
        } else {
            // Navigate to property detail page
            navigate(`/property/${property.id}`);
        }
    };

    return (
        <div className="property-card" onClick={handleClick}>
            <div className="property-image">
                {property.imageUrl || property.image_url ? (
                    <img 
                        src={property.imageUrl || property.image_url} 
                        alt={property.title}
                        onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'flex';
                        }}
                    />
                ) : null}
                <div style={{ display: property.imageUrl || property.image_url ? 'none' : 'flex' }}>
                    {property.image}
                </div>
                <span className="property-badge">{property.badge}</span>
            </div>
            <div className="property-content">
                <div className="property-price">${property.price.toLocaleString()}</div>
                <h3 className="property-title">{property.title}</h3>
                <div className="property-location">
                    <i className="fas fa-map-marker-alt"></i>
                    {property.location}
                </div>
                <div className="property-features">
                    <div className="property-feature">
                        <i className="fas fa-bed"></i>
                        <span>{property.bedrooms} Bed</span>
                    </div>
                    <div className="property-feature">
                        <i className="fas fa-bath"></i>
                        <span>{property.bathrooms} Bath</span>
                    </div>
                    <div className="property-feature">
                        <i className="fas fa-ruler-combined"></i>
                        <span>{property.area} sqft</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PropertyCard;
